<script setup lang="ts">
import {Button, Label, RadioButton} from "@/Components/Library";

const {totalActiveFilters} = defineProps<{totalActiveFilters?: number}>();

const type = defineModel<"contacts" | "invitations">();
const emit = defineEmits(["apply", "clear"]);
</script>

<template>
    <div>
        <div class="mb-4">
            <h3 class="mb-2 text-lg font-bold">Filter by invitation status</h3>
            <div class="flex flex-col gap-3">
                <div class="flex items-center gap-1">
                    <RadioButton
                        input-id="invitation_accepted"
                        name="invitation_status"
                        v-model="type"
                        value="contacts"
                    />
                    <Label for="invitation_accepted">Accepted</Label>
                </div>
                <div class="flex items-center gap-1">
                    <RadioButton
                        input-id="invitation_pending"
                        name="invitation_status"
                        v-model="type"
                        value="invitations"
                    />
                    <Label for="invitation_pending">Pending</Label>
                </div>
            </div>
        </div>
        <div class="flex gap-2" v-auto-animate>
            <Button class="grow bg-askr-green text-white hover:brightness-110" @click="emit('apply')">Apply</Button>
            <Button
                v-if="totalActiveFilters"
                class="w-10 shrink-0 bg-red-600 text-white hover:brightness-110"
                @click="emit('clear')"
                :icon="{icon: 'mdi:filter-off-outline', width: '24'}"
            />
        </div>
    </div>
</template>

<style scoped></style>
